<template>
    <div id="translations">
        <ViewIntro :title="$t('views.translationsView.intro.title')" :message="$t('views.translationsView.intro.message')"></ViewIntro>

        <card-table>
            <template v-slot:title>
                {{ $t('views.translationsView.title') }}
            </template>

            <template v-slot:content>
                <v-layout row wrap>
                <v-flex xs12 v-if="loading">
                    <div class="text-xs-center">
                        <v-progress-circular
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                    </div>
                </v-flex>
                <v-flex v-else-if="!loading && items.length === 0" xs12>
                    <div class="text-xs-center">
                        <p>{{ $t('views.translationsView.noTranslations') }}</p>
                    </div>
                </v-flex>
                <v-flex xs12 v-else>
                    <v-expansion-panel>
                        <v-expansion-panel-content
                            v-for="(item,i) in items"
                            :key="i"
                        >
                            <template v-slot:header>
                                <div v-if="item[currentLocale].title">{{ item[currentLocale].title }}</div>
                                <div v-else>-</div>
                            </template>
                            <v-card>
                                <v-card-text class="mx-2">
                                    <v-divider class="pb-3"></v-divider>
                                    <TranslationEntry
                                        v-for="translation in computeTranslations(item)"
                                        :key="translation.translation"
                                        :language="translation.language"
                                        :translation="translation.translation"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-flex>
                </v-layout>
            </template>
        </card-table>
    </div>
</template>


<script>
import CardTable from "@/components/ui/CardTable";
import ViewIntro from "@/components/common/ViewIntro";
import TranslationEntry from "@/components/translations/TranslationEntry.vue";

export default {
    name: "TranslationsView",
    components: {
        CardTable,
        ViewIntro,
        TranslationEntry
    },
    computed: {
        currentLocale: function() {
            return this.$store.getters.getLocale;
        }
    },
    methods: {
        fetchTranslations: function() {
            this.loading = true;

            this.$http.get(`/translations`).then(res => {
                this.items = res.data;
            }).catch(err => {
                console.log(err);
                this.items = [];
            }).finally(() => {
                this.loading = false;
            })
        },
        computeTranslations: function(item) {
            return [
                {
                    language: this.$i18n.t('common.german'),
                    translation: item.de.translation
                },
                {
                    language: this.$i18n.t('common.italian'),
                    translation: item.it.translation
                },
                {
                    language: this.$i18n.t('common.english'),
                    translation: item.en.translation
                },
                {
                    language: this.$i18n.t('common.french'),
                    translation: item.fr.translation
                }
            ]
        }
    },
    mounted() {
        this.fetchTranslations();
    },
    data() {
        return {
            items: undefined,
            loading: true
        }
    }
}
</script>